<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="BrandForm" label-width="auto" label-position="right">
      <el-form-item label="选择商品：">
        <div v-for="(item, index) in purchaseList" :key="item.id" class="commodity-item">
          <div>
            <div v-if="item.commodityImgList.length > 0" class="item-img">
              <el-image class="item-img" fit="cover" :src="item.commodityImgList[0].smallImg"><template #error><div class="el-img-error" style="font-size: 6px">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="cover"><template #error><div class="el-img-error" style="font-size: 6px">暂无图片</div></template></el-image>
            </div>
          </div>
          <div style="flex: 1; width: 70%">
            <p class="item-name">名称：{{item.commodityName}}</p>
            <p class="item-name">品牌：{{item.brandName}}</p>
          </div>
          <div v-if="idx == -1" class="del-btn" @click="delItem(index, item)"><ElIcons name="CloseBold" color="#666666"/></div>
        </div>
        <div class="commodity-item" style="cursor: pointer" @click="selectCommodity">
          <p  style="text-align: center; width: 100%; font-size: 24px;">+</p>
        </div>
      </el-form-item>
      <el-form-item label="快递单号：">
        <el-input v-model="storageForm.trackingNumber" placeholder="请输入快递单号" />
      </el-form-item>
      <el-form-item label="发货地址：">
        <el-input v-model="storageForm.shipAddress" placeholder="请输入发货地址" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"/>
      </el-form-item>
      <el-form-item label="快递运费：">
        <el-input v-model="storageForm.freight" placeholder="请输入快递运费" />
      </el-form-item>
      <el-form-item label="入库货单：">
<!--        <div class="img-box" v-if="src">-->
<!--          <img :src="src" alt=""  @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">-->
<!--          <div class="delIcon" @click="delImg()"><ElIcons name="CloseBold" color="#ffffff"/></div>-->
<!--        </div>-->

        <div>
          <el-space>
            <div class="img-box" v-for="(item, index) in imgArray.slice(0, 4)" :key="item.id">
              <el-image style="width: 80px; height: 80px; cursor: pointer" @click="showImg(index)" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              <div class="delIcon" @click="delImg(index)"><ElIcons name="CloseBold" color="#ffffff"/></div>
            </div>
            <div class="add" @click="fileUpdate">
              <span>+</span>
            </div>
          </el-space>
          <div>
<!--            <el-button @click="fileUpdate">+ 上传图片</el-button>-->
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
          </div>
        </div>

<!--        <div class="add" @click="headImgUpdate" v-else>-->
<!--          <span>+</span>-->
<!--        </div>-->
<!--        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">-->
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, getFormData, imgPostFormData} from "@/api/api"
import { addOrUpdatePurchase, getSysPositionList, updateStockImgDel } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";
import Dialog from "@/assets/js/dialog";
import StorageListDialog from "@/views/commodity/components/StorageListDialog";
import PlanPurchaseCommodity from "@/views/commodity/components/PlanPurchaseCommodity";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      purchaseList: this.value.purchaseList,
      storageForm: this.value.storageForm,
      idx: this.value.ids,
      shopId: this.value.shopId,

      files: null,
      src: this.value.ids > -1?this.value.storageForm.waybillSmallImg:'',

      loading: false,
      imgArray: this.value.storageForm.stockImgList?this.value.storageForm.stockImgList:[],
    }
  },
  methods: {

    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.imgArray.length; i++) {
        imgList.push(this.imgArray[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    cancel() {
      this.$emit("close");
    },

    // delImg() {
    //   this.files = null
    //   this.src = ''
    // },
    //
    // //更改或添加
    // headImgUpdate() {
    //   this.$refs.headImg.click();
    // },
    //
    // //选取图片
    // headImgChanged(e) {
    //   if(e.target.files[0]) {
    //     this.files = e.target.files[0];
    //     var windowURL = window.URL || window.webkitURL;
    //     this.src = windowURL.createObjectURL(this.files);
    //   }
    // },

    //更改或添加
    fileUpdate() {
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          this.imgArray.push(obj);
        }
        this.$refs.file.setAttribute('type', 'text')
      }
    },

    // 删除图片
    delImg(idx) {
      if(this.imgArray[idx].id >= 0) {
        // this.delImgIdArray.push(this.imgArray[idx].id);
        this.$confirm('确认删除该图片？').then(() => {
          postFormData(updateStockImgDel, {id: this.imgArray[idx].id}).then(data=> {
            let {msg, code} = data
            if (code == 200) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: msg,
                type: 'success'
              });
              this.imgArray.splice(idx,1);
            }else {
              this.$message({
                showClose: true,
                duration: 2000,
                message: msg,
                type: 'warning'
              });
            }
          })
        })
      }else {
        this.imgArray.splice(idx,1);
      }
    },

    selectCommodity() {
      let _title = '选择提交入库的商品';
      Dialog.open({
        title: _title,
        component: PlanPurchaseCommodity,
        data: {
          width: '1500px',
          shopId: this.shopId,
          purchaseList: this.purchaseList,
        },
        confirm: (result) => {
          this.purchaseList = [...this.purchaseList, ...result]
        }
      })
    },

    summit() {
      // console.log(this.idx)
      if(this.purchaseList.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择需要提交入库的商品',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.storageForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('shopId', this.shopId);
      param.append('trackingNumber', this.storageForm.trackingNumber?this.storageForm.trackingNumber:'');
      param.append('shipAddress', this.storageForm.shipAddress?this.storageForm.shipAddress:'');
      param.append('freight', this.storageForm.freight?this.storageForm.freight:0);
      // param.append('file', this.files);
      for(let i = 0; i < this.imgArray.length; i++) {
        if(!this.imgArray[i].id) {
          param.append('file' + i, this.imgArray[i].files);
        }
      }

      let arr = []
      this.purchaseList.map((item) => {
        arr.push(item.id)
      })
      param.append('stockCommodityIds', arr.toString());
      imgPostFormData(addOrUpdatePurchase, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },

    delItem(idx, item) {
      this.$confirm('确认移除商品【' + item.commodityName + '】？').then(() => {
        this.purchaseList.splice(idx, 1)
      })
    }

  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}

.item-img {
  width: 36px;
  height: 36px;
  margin-right: 10px;
}

.commodity-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 12px;
  border: 1px #ebeef5 solid;
  line-height: 1.3;
  border-radius: 6px;
  margin: 0 6px 6px 0;
  font-size: 13px;
  position: relative;
  overflow: hidden;
  width: 42%;
  height: 64px;
}

.del-btn {
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 6px;
  /*padding: 4px;*/
  cursor: pointer;
}

.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.item-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
